// extracted by mini-css-extract-plugin
module.exports = {"HeaderLeft":"style_HeaderLeft__ZRoMY","HeaderRight":"style_HeaderRight__3UzVT"};